import styled from 'styled-components';

import { DefaultSearchType } from 'algolia-api/types/DefaultSearchType';
import { PageHeaderSearchMenu } from 'components/Search/PageHeaderSearchMenu';
import { StaffPageHeaderSearchMenu } from 'components/Search/StaffPageHeaderSearchMenu';
import { NoAmp } from 'containers/NoAmp';
import { cssBreakpoints, shadows, transition } from 'theme/theme';

type Props = {
  defaultSearchType?: DefaultSearchType;
  hasPostSearchToolbar: boolean;
  navSection: 'MAIN' | 'STAFF';
  onSearch?: () => void;
  showStickyMenu: boolean;
  searchMode: boolean;
  searchOpen: boolean;
  toggleSearch: (searchOpen: boolean) => void;
  renderWithSearchHero: boolean;
};

const Menu = styled.div<{ $sticky?: boolean }>`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    top: 0;
    left: 0;
    z-index: 102;

    box-shadow: ${(props) => (props.$sticky ? shadows.toolbar : 'none')};

    ${(props) => (props.$sticky ? 'position: sticky;' : undefined)}
  }
`;

const OffsetStickyMenu = styled.div<{
  $isVisible?: boolean;
  $showOnMobile: boolean;
}>`
  transform: ${({ $showOnMobile }) =>
    $showOnMobile ? 'translateY(0)' : 'translateY(-100%) translateY(-4px)'};
  transition: all ${transition};
  will-change: transform;
  z-index: 104;
  position: fixed;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    transform: ${({ $isVisible }) =>
      $isVisible ? 'translateY(0)' : 'translateY(-100%) translateY(-4px)'};

    top: 0;
    left: 0;
    box-shadow: ${shadows.toolbar};
    display: block;
  }
`;

export function LayoutSearchToolbar({
  defaultSearchType,
  hasPostSearchToolbar,
  renderWithSearchHero,
  navSection,
  onSearch,
  searchMode,
  searchOpen,
  toggleSearch,
  showStickyMenu,
}: Props) {
  const search = () => {
    if (onSearch) onSearch();
  };

  const searchMenu =
    navSection === 'STAFF' ? (
      <StaffPageHeaderSearchMenu
        onSearch={search}
        searchOpen={searchOpen}
        toggleSearch={toggleSearch}
      />
    ) : (
      <PageHeaderSearchMenu
        searchMode={searchMode}
        navSection={navSection}
        onSearch={search}
        defaultSearchType={defaultSearchType}
        searchFrom="Header Search Bar"
        searchOpen={searchOpen}
        toggleSearch={toggleSearch}
      />
    );

  return (
    <NoAmp>
      {renderWithSearchHero ? (
        <OffsetStickyMenu
          $isVisible={showStickyMenu}
          $showOnMobile={searchOpen}
        >
          {searchMenu}
        </OffsetStickyMenu>
      ) : (
        <Menu $sticky={searchMode || !hasPostSearchToolbar}>{searchMenu}</Menu>
      )}
    </NoAmp>
  );
}
